export const allowedColorModuleProducts = [
    'HERO.1',
    'HERO.2',
    'HERO.3',
    'HERO.5',
    'HERO.5X',
    'TERO.1',
    'TERO.2',
    'OLIMP',
    'OLIMP.x',
    'ROLTEK SCREEN',
    'ROLO VRATA',
    'GECCO',
    'F400',
    'SILENTO.2',
    // Shutters products
    'PENTO',
    'INTEGO',
    'RONDO',
    'Q.INTEGO',
    'QUADRO.E',
    'RA.2',
    'KARO',
    'PURO.2.XR',
    'VISIO',
    'VECTO',
    'VECTO.E',
    'KLASIKA',
];

export const allowedColorModuleProductGroups = ['Komarniki'];

export const allowedColorModuleProductSubGroups = [
    // String.raw`Rolete\Predokenske`
];
